<template>
  <div>
    <iframe
      width="100%"
      height="500"
      scrolling="no"
      frameborder="no"
      allow="autoplay"
      v-bind:src="embedSrc"
    ></iframe>
    <p>
      <router-link :to="{ name: 'search'}">戻る</router-link>
    </p>
  </div>
</template>

<script>
export default {
  name: "Episode",
  data() {
    return {
      id: this.$route.params.id,
      embedSrc:
        "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/" +
        this.$route.params.id +
        '&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"'
    };
  },
  props: {
    title: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
